var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightFoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100",
    width: 150,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fbc3a4}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m12.8 67c0 8.7 16.4 6.9 54 6.9 37.5 0 60.8 0.7 67.9-4.2 3.3-2.3 3.7-19.9-9-21.3-18.3-7.1-37.8-22.9-58.9-22.9-23.4 0-26.9 7.8-39.2 19.5-7.3 7.1-14.8 18.8-14.8 22z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightFoot);
export default __webpack_public_path__ + "static/media/right_foot.ea262c7563970cfdaa8e7e22e3b1c01a.svg";
export { ForwardRef as ReactComponent };